import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../store';
import { SingleValueKPI } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

@Injectable()
export class ClosedCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter((t) => t.IsClosed).length || 0;

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: 'Closed Cases',
          title: 'All Closed Tickets',
          value: dataValue,
          linkEnabled: true,
          linkParams: { groupBy: 'Status', view: 'closed' },
          hyperlink: '/tickets',
        } satisfies SingleValueKPI,
      };
    }),
  );
}
